import { createAction, createSlice } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slice
const inboxSlice = createSlice({
  name: 'chat',
  initialState: initialStore.chat,
  reducers: {
    getPatientConversationData: (state, { payload }) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setPatientConversationData: (state, { payload }) => {
      if (state.isLoading) {
        state.isLoading = false;
      }
      state.data = payload;
    },
    setPatientConversationDataFail: (state) => {
      if (state.isLoading) {
        state.isLoading = false;
      }
    },
    getUnreadCount: (state, { payload }) => {
      if (state.isLoading) {
        state.isLoading = false;
      }
    },
    setTotalUnreadMessages: (state, { payload }) => {
      state.totalUnreadMessages = payload;
    }
  }
});

export const {
  getPatientConversationData,
  setPatientConversationData,
  setPatientConversationDataFail,
  getUnreadCount,
  setTotalUnreadMessages
} = inboxSlice.actions;

export const { reducer } = inboxSlice;

// Selectors

export const getConversationsLoadingSelector = (state: IState) =>
  state && state.chat.isLoading;

export const getConversationPatientSelector = (state: IState) =>
  state && state.chat.patientId;

export const getConversationDataSelector = (state: IState) =>
  state && state.chat.data;

export const getUnreadCountSelector = (state: IState) =>
  state && state.chat.totalUnreadMessages;
